import { ResumeSGChargeEntity } from "domain/entity/ResumeSGCharge/ResumeSGChargeEntity";
import { axiosPostData } from "../axios/AxiosBasicImpl";
import chargeAxiosInstance from "../axios/chargeAxiosInstance";
import { ResumeSGChargeRepository } from "./ResumeSGChargeRepo";
import { ResumeSGChargeSearchCriteria } from "domain/entity/ResumeSGCharge/ResumeSGChargeSearchCriteria";
import { ResponseEntity } from "domain/entity/Common/ResponseEntity";

export const ResumeSGChargeRepoImpl = () : ResumeSGChargeRepository => {

    const getResumeSGDatas = async(searchCriteria: ResumeSGChargeSearchCriteria) : Promise<ResumeSGChargeEntity[]> => {
        const url = "/v1/resumeSG/search";
        return axiosPostData(chargeAxiosInstance, `${url}`, searchCriteria).then(res => {
            const data = res.data;
            return data;
        }).catch(err => {
            return [];
        });
    }

    const onSubmit = async(dataKeyMap: { [key: number]: string }) : Promise<ResponseEntity> => {
        const newUrl = "/v1/resumeSG/submit";
        return await axiosPostData(chargeAxiosInstance, `${newUrl}`, dataKeyMap);
    }
    return {
        getResumeSGDatas: getResumeSGDatas,
        onSubmit: onSubmit
    }
}